import { Component, PropsWithChildren } from 'react'

type Props = {
  logger: {
    error: (err: Error) => void
  }
}

export class ErrorBoundary extends Component<PropsWithChildren<Props>> {
  componentDidCatch(error) {
    this.props.logger.error(error)
  }

  render() {
    return this.props.children
  }
}
